import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "rsuite/dist/rsuite.min.css";
import "./theme.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { installGlobalErrorHandlers } from "./utils/globalErrorHandlers";
import { initTelemetry } from "./config/telemetry";

// Configure Rapid7 telemetry, then forward uncaught errors + unhandled
// promise rejections to it.
initTelemetry();
installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ErrorBoundary>
        <App />
    </ErrorBoundary>
);

reportWebVitals();
